import { db, storage } from "../firebase";
import {
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";

import {
  ref,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";

export const saveJobApplication = async (application) => {
  try {
    console.log("Step 1: Starting upload");

    let resumeUrl = "";

    if (application.resume) {
      console.log("Step 2: Resume selected", application.resume.name);

      const resumeRef = ref(
        storage,
        `jobApplications/resumes/${Date.now()}_${application.resume.name}`
      );

      console.log("Step 3: Uploading...");

      await uploadBytes(resumeRef, application.resume);

      console.log("Step 4: Upload complete");

      resumeUrl = await getDownloadURL(resumeRef);

      console.log("Step 5: URL =", resumeUrl);
    }

    console.log("Step 6: Saving Firestore");

    const { resume, ...applicationData } = application;

    const docRef = await addDoc(
      collection(db, "jobApplications"),
      {
        ...applicationData,
        resumeUrl,
        status: "New",
        createdAt: serverTimestamp(),
      }
    );

    console.log("Step 7: Firestore saved", docRef.id);

    return docRef.id;
  } catch (err) {
    console.error("JOB APPLICATION ERROR:", err);
    throw err;
  }
};